/**
 * Dependencies
 */
import Segment from 'segment-js';

(function() {
	const ease = {
		ease: function(type, exp, duration) {
			switch (type) {
				case 'elastic-in':
					return function(t) {
						exp = exp || 1;
						duration = duration || 0.3;
						const a = duration * (2 * Math.PI) / 0.3;
						const s = duration * Math.asin(1 / exp);
						return -1 * exp * Math.pow(2, 10 * (t - 1)) * Math.sin((t - 1 - s / a) * a);
					};
				case 'elastic-out':
					return function(t) {
						exp = exp || 1;
						duration = duration || 0.3;
						const a = duration * (2 * Math.PI) / 0.3;
						const s = duration * Math.asin(1 / exp);
						return exp * Math.pow(2, -10 * t) * Math.sin((t - s / a) * a) + 1;
					};
				case 'bounce-out':
					return function(t) {
						exp = exp || 1;
						if (t < (1 / 2.75)) {
							return 7.5625 * t * t;
						} else if (t < (2 / 2.75)) {
							return 7.5625 * (t -= (1.5 / 2.75)) * t + 0.75;
						} else if (t < (2.5 / 2.75)) {
							return 7.5625 * (t -= (2.25 / 2.75)) * t + 0.9375;
						} else {
							return 7.5625 * (t -= (2.625 / 2.75)) * t + 0.984375;
						}
					};
				default:
					return function(t) { return t; };
			}
		}
	};

	var beginAC = 80,
		endAC = 320,
		beginB = 80,
		endB = 320,
		to;
	
	const inAC = (s) => s.draw('80% - 240', '80%', 0.3, {
		delay: 0.1,
		callback: () => inAC2(s),
	});
	
	const inAC2 = (s) => s.draw('100% - 545', '100% - 305', 0.6, {
		easing: ease.ease('elastic-out', 1, 0.3),
	});
	
	const inB = (s) => s.draw(beginB - 60, endB + 60, 0.1, {
		callback: () => inB2(s),
	});
	
	const inB2 = (s) => s.draw(beginB + 120, endB - 120, 0.3, {
		easing: ease.ease('bounce-out', 1, 0.3),
	});
	
	const outAC = (s) => s.draw('90% - 240', '90%', 0.1, {
		easing: ease.ease('elastic-in', 1, 0.3),
		callback: () => outAC2(s),
	});
	
	const outAC2 = (s) => s.draw('20% - 240', '20%', 0.3, {
		callback: () => outAC3(s),
	});
	
	const outAC3 = (s) => s.draw(beginAC, endAC, 0.7, {
		easing: ease.ease('elastic-out', 1, 0.3),
	});
	
	const outB = (s) => s.draw(beginB, endB, 0.7, {
		delay: 0.1,
		easing: ease.ease('elastic-out', 2, 0.4),
	});
	
	var pathA = document.getElementById('pathA'),
		pathB = document.getElementById('pathB'),
		pathC = document.getElementById('pathC'),
		segmentA = new Segment(pathA, beginAC, endAC),
		segmentB = new Segment(pathB, beginB, endB),
		segmentC = new Segment(pathC, beginAC, endAC),
		trigger = document.getElementById('menu-burger-trigger'),
		toCloseIcon = true,
		menu = document.getElementById('menu'),
		wrapper = document.getElementById('menu-burger');

	wrapper.style.visibility = 'visible';

	trigger.onclick = () => {
		if (toCloseIcon) {
			inAC(segmentA);
			inB(segmentB);
			inAC(segmentC);
			menu.className = 'menu is-open is-transitioned is-opening';
		} else {
			outAC(segmentA);
			outB(segmentB);
			outAC(segmentC);
			menu.className = 'menu is-open is-transitioned is-closing';
			to = setTimeout(() => {
				menu.className = 'menu is-transitioned';
				if (to) {
					clearTimeout(to);
				}
				to = setTimeout(() => {
					menu.className = 'menu';
					if (to) {
						clearTimeout(to);
					}
				}, 500);
			}, 300);
		}
		toCloseIcon = !toCloseIcon;
	};
})();